import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import MetaBookingModal from '../../../MetaBooking/modals/MetaBookingModal';
import { useAuthContext } from '../../../../../../context/AuthContext';
import getAbilityForReservation from './helpers/getAbilityForReservation';
import usePlanStore from '../../../../../../store/planStore';
import useCheckMetaBooking from '../OverridingBookingFlow/hooks/useCheckMetaBooking';
import useMetaPredictionsValidity from '../OverridingBookingFlow/hooks/useMetaPredictionsValidity';

export interface BookingFlowProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onSecondaryAction: () => void;
  header: string;
}

function SaveBookingFlow({
  open,
  onClose,
  onSuccess,
  onSecondaryAction,
  header,
}: BookingFlowProps) {
  const { userRoles } = useAuthContext();
  const { t } = useTranslation();

  if (getAbilityForReservation(userRoles)) {
    return (
      <MetaBookingModal
        open={open}
        onClose={onClose}
        onSuccess={onSuccess}
        onSecondaryAction={onSecondaryAction}
        header={t('mediaPlanning.metaBooking.modals.bookMeta.header')}
        text={t('mediaPlanning.metaBooking.modals.bookMeta.text')}
        cancelText={t('mediaPlanning.metaBooking.modals.bookMeta.cancelText')}
        proceedText={t('mediaPlanning.metaBooking.modals.bookMeta.proceedText')}
        secondaryActionText={t(
          'mediaPlanning.metaBooking.modals.bookMeta.secondaryActionText'
        )}
      />
    );
  }

  return (
    <MetaBookingModal
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
      header={t('mediaPlanning.metaBooking.modals.insufficientRights.header')}
      text={t('mediaPlanning.metaBooking.modals.insufficientRights.text')}
      cancelText={t(
        'mediaPlanning.metaBooking.modals.insufficientRights.cancelText'
      )}
      proceedText={t(
        'mediaPlanning.metaBooking.modals.insufficientRights.proceedText'
      )}
    />
  );
}

export default SaveBookingFlow;
